export default __webpack_public_path__ + "static/media/chevron-right.e9dec063.svg";